// extracted by mini-css-extract-plugin
export var actionButton = "_n2-0";
export var actionMenuContainer = "_n2-i";
export var bubble = "_n2-2";
export var bubbleActionMenu = "_n2-j";
export var bubbleContext = "_n2-6";
export var bubbleItems = "_n2-7";
export var customer = "_n2-3";
export var divider = "_n2-8";
export var fileList = "_n2-9";
export var hiddenComment = "_n2-o";
export var infoAbove = "_n2-a";
export var internal = "_n2-4";
export var lightActionButton = "_n2-1";
export var link = "_n2-b";
export var merchant = "_n2-5";
export var message = "_n2-c";
export var profilePicture = "_n2-e";
export var quillToolbarContainer = "_n2-f";
export var senderDate = "_n2-g";
export var senderDateCustomer = "_n2-h";
export var senderName = "_n2-d";
export var time = "_n2-k";
export var uploadedImage = "_n2-l";
export var username = "_n2-m";
export var xsmall = "_n2-n";